import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('Mission')
export class Mission {

  @JsonProperty('mission_id', Number)
  missionId: number = 0;

  @JsonProperty('type', Number)
  type: number = 0;

  @JsonProperty('start_date_timestamp', Number)
  startDateTimestamp: number = 0;

  @JsonProperty('end_date_timestamp', Number)
  endDateTimestamp: number = 0;

  @JsonProperty('complete_quantity', Number)
  completeQuantity: number = 0;

  @JsonProperty('points_reward', Number)
  pointsReward: number = 0;

  @JsonProperty('custom_param', Number)
  customParam: number = 0;

  @JsonProperty('users_count', Number)
  usersCount: number = 0;
}
